import { render, staticRenderFns } from "./DialogInfo.vue?vue&type=template&id=df75bd7c&scoped=true"
import script from "./DialogInfo.vue?vue&type=script&lang=js"
export * from "./DialogInfo.vue?vue&type=script&lang=js"
import style0 from "./DialogInfo.vue?vue&type=style&index=0&id=df75bd7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df75bd7c",
  null
  
)

export default component.exports